<template>
	<div class="userAdmin">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="380px" :close="handleClose">
			<div class="dialogMain">
				<dl>
					<dt>&ensp;&emsp;用户名：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.usr" class="inputwidth" v-show="this.dialogTitle!='编辑管理员'"></el-input>		
						<el-input v-model="dialogData.usr" class="inputwidth" disabled v-show="this.dialogTitle=='编辑管理员'"></el-input>	
					</dd>
				</dl>						
				<dl v-show="this.dialogTitle=='编辑管理员'">
					<dt><span class="checktip">* </span>&emsp;旧密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.oPwd"  type="password" class="inputwidth"></el-input>						
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">* </span>设置密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.pwd" type="password" class="inputwidth"></el-input>						
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">* </span>确定密码：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.confirmPwd" type="password" class="inputwidth"></el-input>						
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<!--导航条-->
		<navZcy v-bind:num="'6-1'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<div class="top cf">
				<div class="topL fl"><span>用户管理</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="150px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="200px">
						</el-table-column>
						<el-table-column prop="usr" label="用户名" width="250px">						
						</el-table-column>
						<el-table-column prop="pwd" label="密码" width="350px">						
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogTitle: "", 		//弹出框标题
			dialogVisible: false,	//是否显示弹出框
			dialogData: {},			//弹出框参数
			tableData: [], 			//列表内容
			multipleSelection: []
		}
	},
	methods: {
		refresh() {
			location.reload();
		},
		//获取管理员
		getAdmin() {
			let url = "/lightApi/admin/inquiryAdmin/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.getAdminFn,'vue':this})
		},
		getAdminFn(data) {
			console.log(data)
			
			if(data.msg=="ok"){	
				this.tableData = data.data.items
			}else{
				this.tableData = []
			}
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//添加管理员
		handleAdd: function() {
			this.loading =false
			this.dialogTitle = "添加管理员";
			this.dialogData={
				usr: '',
				pwd: ''
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//编辑管理员
		handleEdit: function(index, row) {
			this.loading =false
			this.dialogTitle = "编辑管理员";
			this.dialogData = {
				id: row.id,
				usr: row.usr,
				oPwd: '',
				pwd: '',
				confirmPwd: ''
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//确定添加/编辑
		handleConfirm: function() {
			this.loading = true		
			if(this.dialogData.usr.trim()!=""&&this.dialogData.pwd.trim()!=""&&this.dialogData.confirmPwd.trim()==this.dialogData.pwd.trim()){
				let data = {
					usr: this.dialogData.usr.trim()
				}
				let url = ""
				if(this.dialogTitle == "添加管理员"){
					data.pwd = this.dialogData.pwd
					url = "/lightApi/admin/createAdmin/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/admin/modifyPassowrd/"+sessionStorage.getItem('sessionId')
					data.oldPwd = this.dialogData.oPwd.trim(),
					data.newPwd = this.dialogData.pwd.trim()
				}
				console.log(data)
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				if(this.dialogData.usr.trim()==""){
					this.$message({
						type: 'error',
						message: '用户名不能为空'
					});
				}else if(this.dialogData.pwd.trim()==""){
					this.$message({
						type: 'error',
						message: '设置的密码不能为空'
					});
				}else if(this.dialogData.confirmPwd.trim()!=this.dialogData.pwd.trim()){
					this.$message({
						type: 'error',
						message: '密码与确定密码不一致'
					});					
					this.dialogData.pwd = ''
					this.dialogData.confirmPwd = ''
				}
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.getAdmin()
				this.dialogVisible = false
			}else{
				this.dialogData.oPwd = ''
				this.dialogData.pwd = ''
				this.dialogData.confirmPwd = ''
				this.loading = false		
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//复选框选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除系列风格
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/admin/deleteAdmin/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){	
				this.getAdmin()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		}
	},
	mounted() {
		this.getAdmin()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>	
	.inputwidth{
		width: 200px;
	}
</style>


// WEBPACK FOOTER //
// src/components/userAdmin.vue